import { WbTooltip } from '@agilelab/plugin-wb-platform';
import { ReactElement, useMemo } from 'react';
import { WittyTableColumn } from '../../contexts';
import { composeNoContextMessage } from './messages';

export type WittyNoContextTooltipProps = {
  triggeringColumns: WittyTableColumn[];
  children: ReactElement;
  hide?: boolean;
};

export const WittyNoContextTooltip = ({
  triggeringColumns,
  children,
  hide = true,
}: WittyNoContextTooltipProps) => {
  const message = useMemo(
    () => composeNoContextMessage(triggeringColumns),
    [triggeringColumns],
  );
  return (
    <WbTooltip title={message} disableHoverListener={hide}>
      {children}
    </WbTooltip>
  );
};
